<template>
  <div :class="wrapperClasses">
    <div :class="classes">
      <label v-if="label">{{ label }}</label>
      <select ref="select" v-bind="$attrs" class="no-init">
        <option v-if="initialValue" :value="initialValue.value">
          {{ initialValue.label }}
        </option>
        <option
          v-for="option in options || []"
          :key="option.value"
          :value="option.value"
          :selected="option.value == $attrs.value"
        >
          {{ option.label }}
        </option>
      </select>
      <input
        v-if="hasSearch"
        type="text"
        class="search-input bg-dark-29 px-4 left-0 w-full absolute top-7 hidden z-1000 text-sm"
        :placeholder="t('Search')"
        @input="$emit('search', $event)"
      />
    </div>
  </div>
</template>

<script>
/* globals App $ */
export default {
  inheritAttrs: false,
  props: {
    error: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    options: {
      type: Array,
    },
    hasSearch: {
      type: Boolean,
    },
    initialValue: {
      type: Object,
    },
    wrapperClasses: {
      type: String,
    },
    noMatchesLabel: {
      type: String,
    },
  },
  emits: ["search", "change"],
  computed: {
    classes() {
      return {
        "select-container": true,
        "border-red-500": this.error,
        "has-search-input": this.hasSearch,
        border: true,
        "border-dark-29": !this.error,
      };
    },
  },
  watch: {
    options() {
      this.$nextTick(() => {
        $(this.$refs.select).multipleSelect("refresh");
      });
    },
  },
  mounted() {
    window.App.getForms().then(() => {
      let options = {
        onClick: (event) => {
          this.$emit("change", { label: event.text, value: event.value });
        },
      };
      if (this.noMatchesLabel) {
        options.formatNoMatchesFound = () => {
          return this.noMatchesLabel;
        };
      }
      App.forms.initSelect(this.$refs.select, options);
    });
  },
};
</script>
